import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessLog } from '@api/data-security';

export const getCoreDataSecurityAccessLogSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessLog',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessLog,
	retainDataOnRequest: true
});
